import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { MenuItem } from '@mui/material'
import { DropdownMenu } from '@/components/DropdownMenu'

import { MarketTypes } from '../constants'
import { OddsFilters } from '../types'
import { OddsDataRow } from './oddsData.dde.table'
import { generateOddsDataCsv } from './oddsDataCsvExport.utils'

type OddsDataExcelExportProps = {
  tableRows: OddsDataRow[]
  filters: OddsFilters
  tournamentName?: string
  playerNames?: string[]
  marketType: MarketTypes
  selectedPlayerNames?: string[]
}

const hasModelledOdds = (tableRows: OddsDataRow[]): boolean => {
  return tableRows.some((row) => {
    if (row.odds.modelledOdds !== '-' && typeof row.odds.modelledOdds === 'number') {
      return true
    }
    return row.players.some(
      (player) => player.modelledOdds !== '-' && typeof player.modelledOdds === 'number'
    )
  })
}

export const OddsDataExcelExport = ({
  tableRows,
  filters,
  tournamentName = 'Tournament',
  playerNames,
  marketType,
  selectedPlayerNames
}: OddsDataExcelExportProps) => {
  const canExportWithModelled = hasModelledOdds(tableRows)

  const handleDownloadWithModelled = () => {
    generateOddsDataCsv({
      tableRows,
      filters,
      tournamentName,
      playerNames,
      marketType,
      includeModelled: true,
      selectedPlayerNames
    })
  }

  const handleDownloadWithoutModelled = () => {
    generateOddsDataCsv({
      tableRows,
      filters,
      tournamentName,
      playerNames,
      marketType,
      includeModelled: false,
      selectedPlayerNames
    })
  }

  return (
    <DropdownMenu
      label="Generate Excel report"
      testId="odds-data-excel-export-menu"
      variant="contained"
    >
      <MenuItem onClick={handleDownloadWithModelled} disabled={!canExportWithModelled}>
        <FileDownloadOutlinedIcon sx={{ mr: 1 }} />
        Download Excel with Modelled Comparison
      </MenuItem>
      <MenuItem onClick={handleDownloadWithoutModelled}>
        <FileDownloadOutlinedIcon sx={{ mr: 1 }} />
        Download Excel without Modelled Comparison
      </MenuItem>
    </DropdownMenu>
  )
}
